/**
 * Validator: is required check
 */export default function isRequired(element){return(// use the native API if available
element.validity?!element.validity.valueMissing:element.value&&""!==element.value)}